
import { BarChart3 } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { useTimesheetRecords } from "@/hooks/useTimesheetRecords"
import { useAuth } from "@/hooks/useAuth"

export const WorkSummary = () => {
  const { profile } = useAuth()
  const { data: registros, isLoading } = useTimesheetRecords(profile?.id)

  const calcularHorasHoje = () => {
    if (!registros || !profile?.id) return { trabalhadas: "0h 0m", restantes: "8h 0m" }
    
    const hoje = new Date().toISOString().split('T')[0]
    const registrosHoje = registros.filter(r => r.record_date === hoje && r.employee_id === profile.id)
    
    let entrada = null
    let saida = null
    let saidaAlmoco = null
    let voltaAlmoco = null
    
    registrosHoje.forEach(registro => {
      const recordTime = new Date(registro.record_time)
      switch (registro.record_type) {
        case 'entrada':
          entrada = recordTime
          break
        case 'saida':
          saida = recordTime
          break
        case 'saida_almoco':
          saidaAlmoco = recordTime
          break
        case 'volta_almoco':
          voltaAlmoco = recordTime
          break
      }
    })
    
    let horasTrabalhadas = 0
    
    if (entrada && saida) {
      // Jornada completa
      const totalMs = saida.getTime() - entrada.getTime()
      
      if (saidaAlmoco && voltaAlmoco) {
        const almocoMs = voltaAlmoco.getTime() - saidaAlmoco.getTime()
        horasTrabalhadas = (totalMs - almocoMs) / (1000 * 60 * 60)
      } else {
        horasTrabalhadas = totalMs / (1000 * 60 * 60)
      }
    } else if (entrada) {
      // Trabalhando agora
      const agora = new Date()
      let totalMs = agora.getTime() - entrada.getTime()
      
      if (saidaAlmoco && voltaAlmoco) {
        // Voltou do almoço, conta tempo total menos tempo de almoço
        const almocoMs = voltaAlmoco.getTime() - saidaAlmoco.getTime()
        horasTrabalhadas = (totalMs - almocoMs) / (1000 * 60 * 60)
      } else if (saidaAlmoco && !voltaAlmoco) {
        // Está no almoço, conta só até a saída para almoço
        const trabalhadoMs = saidaAlmoco.getTime() - entrada.getTime()
        horasTrabalhadas = trabalhadoMs / (1000 * 60 * 60)
      } else {
        // Trabalhando normalmente
        horasTrabalhadas = totalMs / (1000 * 60 * 60)
      }
    }
    
    // Garantir que não seja negativo
    horasTrabalhadas = Math.max(0, horasTrabalhadas)
    
    const horas = Math.floor(horasTrabalhadas)
    const minutos = Math.floor((horasTrabalhadas - horas) * 60)
    const trabalhadas = `${horas}h ${minutos}m`
    
    const horasRestantes = Math.max(0, 8 - horasTrabalhadas)
    const horasRest = Math.floor(horasRestantes)
    const minutosRest = Math.floor((horasRestantes - horasRest) * 60)
    const restantes = `${horasRest}h ${minutosRest}m`
    
    return { trabalhadas, restantes }
  }

  const { trabalhadas, restantes } = calcularHorasHoje()

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <BarChart3 className="h-5 w-5" />
            <span>Resumo da Jornada</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-center text-gray-500 py-4">Carregando...</p>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <BarChart3 className="h-5 w-5" />
          <span>Resumo da Jornada</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center">
            <p className="text-sm text-gray-600">Horas Trabalhadas Hoje</p>
            <p className="text-2xl font-bold text-green-600">{trabalhadas}</p>
          </div>
          <div className="text-center">
            <p className="text-sm text-gray-600">Horas Restantes</p>
            <p className="text-2xl font-bold text-blue-600">{restantes}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
